<template>
  <div class="terms-container">
    <WaterMark />
    <suspense>
      <main>
        <slot />
      </main>
    </suspense>
  </div>
</template>
<style scoped lang="scss">
.terms-container {
  max-width: 1000px;
  margin: auto;
  background-color: #f9f9f9;
  padding: 24px 0;
}
</style>
